<template>
  <div class="similarArticle" v-show="similarVisible">
    <div
      class="similarArticle-box"
      :style="{ width: width + '%', margin: '10% auto' }"
    >
      <div>
        <slot name="similar-title"></slot>
        <img :src="close" alt="关闭按钮" @click="closeViews()" />
      </div>
      <slot name="similar-detail"></slot>
      <slot name="similar-select"></slot>
      <slot name="similar-table"></slot>
      <slot name="pagination"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimilarArticles",
  data() {
    return {
      close: require("@/common/assets/close.png"),
    };
  },
  props: {
    width: {
      type: Number,
      default: 50,
    },
    similarVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeViews() {
      this.similarVisible = !this.similarVisible;
      // 将修改的参数回传给父级
      this.$emit("similarVisibleFun", this.similarVisible);
    },
  },
};
</script>

<style lang="less">
.similarArticle {
  // float: left;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  .similarArticle-box::after {
    content: "";
    display: block;
    clear: both;
  }
  .similarArticle-box {
    background-color: #fff;
    padding-bottom: 20px;
  }
  .similarArticle-box > div:first-child {
    width: 100%;
    position: relative;
    border: solid 1px #aeaeaeae;
    border-top: none;
    border-left: none;
    border-right: none;
    box-sizing: border-box;
    span {
      font-size: 34px;
      font-weight: 700;
      width: 100%;
      height: 80px;
      line-height: 80px;
      display: inline-block;
      text-align: center;
    }
    img {
      right: 20px;
      top: 20px;
      position: absolute;
      cursor: pointer;
    }
  }
  .similarArticle-box > div:nth-child(2) {
    padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
    // border: solid 1px;
  }
  .similarArticle-box > div:nth-child(2) > span:first-child {
    width: 20%;
    height: 100px;
    margin-top: 20px;
    border: solid 1px #9e9e9e;
    float: left;
    border-radius: 8px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .similarArticle-box > div:nth-child(2) > span:nth-child(2) {
    float: right;
    width: 78%;
    height: 40px;
    margin-top: 20px;
    height: 100px;
    // border: solid 1px;
    display: inline-block;
    span:first-child {
      margin-top: 30px;
      display: inline-block;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 24px;
    }
    span:nth-child(2),
    span:nth-child(3) {
      font-size: 16px;
      margin-top: 4px;
      display: inline-block;
    }
    span:nth-child(3) {
      margin-left: 30px;
    }
  }
  .similarArticle-box > div:nth-child(3) {
    width: 100%;
    display: inline-block;
    margin-top: 30px;
    // border: solid 1px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cw-similar-articles.vue